export default {
  mergeSumAndCount: 'ادغام مجموع و تعداد',
};
